import { DataSourceCode } from "./DataSourceBase";
import { LedgerType } from "./LedgerBase";

export const MAX_TRANSACTION_DESCRIPTION_LENGTH = 1024;

export type TransactionTagType = TransactionType | LedgerType;

export enum TransactionType {
  Trade = "Trade",
  Mint = "Mint",
  Receive = "Receive",
  Send = "Send",
  Rebase = "Rebase",
  Wrap = "Wrap",
  AddLiquidity = "Add Liquidity",
  RemoveLiquidity = "Remove Liquidity",
  Transaction = "Transaction",
}

export enum NeedsReviewType {
  MissingAcquisitionParcel = "MissingAcquisitionParcel",
  MissingData = "MissingData",
  MissingMarketValue = "MissingMarketValue",
  MissingAssetCode = "MissingAssetCode",
  UnclassifiedLedgers = "UnclassifiedLedgers",
  WithdrawalInclusiveOfFee = "WithdrawalInclusiveOfFee",
  UnmatchedTransfer = "UnmatchedTransfer",
  IncompleteRebase = "IncompleteRebase",
}
export interface NeedsReviewReasonBase {
  type: NeedsReviewType;
}

/** Determine whether a given item should be actioned or not */
export function includeNeedsReviewItem({
  type,
}: NeedsReviewReasonBase): boolean {
  // exclude these for now since user cannot action them
  return ![
    NeedsReviewType.MissingData,
    NeedsReviewType.WithdrawalInclusiveOfFee,
  ].includes(type);
}

export enum MetadataKey {
  OrderSide = "Order Side",
  BankAccount = "Bank Account",
  Contract = "Contract",
  ContractAddress = "Contract Address",
  ContractMethod = "Contract Method",
  ContractMethodSignature = "Contract Method Signature", // deprecated
  ContractMethodId = "Contract Method Id", // deprecated
  LinkedDataSource = "Linked DataSource",
}

export interface TransactionMetadataBase {
  name: MetadataKey;
  value: string;
}

export interface TransactionSourceIdBase {
  type: TransactionSourceIdType;
  id: string;
  dataSourceCode?: DataSourceCode;
  dataSource?: any; // TODO: Remove later (deprecated)
}

export enum TransactionSourceIdType {
  EventId = "EventId",
  OrderId = "OrderId",
  TransactionHash = "TransactionHash",
  BlockHash = "BlockHash",
  TransferId = "TransferId",
  TradeId = "TradeId",
  SentFromAddress = "SentFromAddress",
  SentToAddress = "SentToAddress",
  ReceivedFromAddress = "ReceivedFromAddress",
  ReceivedAtAddress = "ReceivedAtAddress",
  DepositId = "DepositId",
  WithdrawalId = "WithdrawalId",
  CorrelationId = "CorrelationId",
}
